<template>
  <div>
    <div id="preloader">
      <div id="status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
    </div>
    <div id="layout-wrapper">
      <HorizontalTopbarInside />
      <SideBar :is-condensed="isMenuCondensed" :type="leftSidebarType" :width="layoutWidth" />
      <div class="main-content">
        <div class="page-content">
          <!-- Start Content-->
          <div class="container-fluid">
            <slot />
          </div>
        </div>
        <Footer />
        <div class="ms-5 mt-5 w-100">
          <AppBreadcrumb />
        </div>
        <b-row>
          <b-col md="4">
            <h2>{{$t('message.Positions')}}</h2>
          </b-col>
          <b-col md="4">
<!--            <b-form-select-->
<!--                v-model="params.position_level_id"-->
<!--                :options="position_level"-->
<!--                text-field="name_uz"-->
<!--                value-field="id"-->
<!--                style="height: 40px; margin-left: 50px"-->
<!--                class="mt-5 w-75"-->
<!--                @input="getLevel"-->
<!--            />-->
          </b-col>
          <b-col md="4">
            <b-button
                size="lg"
                variant="outline-primary"
                style="margin-left: 70px"
                @click="handleAdd"
            ><i class='bx bx-plus'> {{$t('message.Add')}}</i>
            </b-button>
          </b-col>
        </b-row>
        <RanksModal
            :position_level="position_level"
            :id="id"
            :activeModal="activeModal"
            @closeModal="modalClose" />
        <div>
          <b-card
              class="mt-4"
              style="width: 90%; margin: 0 auto;"
              >
            <b-table
                responsive
                striped
                hover
                :items="ranks"
                :fields="fields">
              <template #cell(id)="data">
                <span class="text-md text-primary"> {{ (data.index + 1) }}</span>
              </template>
              <template #cell(action)="data">
                <b-button
                    size="sm"
                    variant="warning"
                    @click="handleEdit(data.item.id)"
                ><i class='bx bx-pencil'></i>
                </b-button>
                <b-button
                    size="sm"
                    style="margin-left: 10px"
                    class="ml-1"
                    variant="danger"
                    @click="handleDelete(data.item.id)"
                ><i class='bx bx-trash'></i>
                </b-button>
              </template>
            </b-table>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Layout from "../../../../../../layouts/main";
import SideBar from "../../../../../../components/side-bar";
import router from "@/router";
import { layoutComputed } from "@/state/helpers";
import RanksModal from "./RanksModal";
import {deletePosition, getPositions, createLevelById} from "../../../../../../api/directories";
import Swal from "sweetalert2";
import HorizontalTopbarInside from "../../../../../../components/horizontal-topbar-inside";
import AppBreadcrumb from "../../../../../layouts/AppBreadcrumb";


export default {
  name: "Ranks",
  components: {
    AppBreadcrumb,
    HorizontalTopbarInside,
    RanksModal,
     SideBar
  },
  data() {
    return {
      id:null,
      position_level: [],
      activeModal: false,
      isMenuCondensed: false,
      ranks:[],
      fields: [
        {
          key: 'id',
          label: this.$t('message.Id'),
        },
        {
          key: 'name_uz',
          label: this.$t('message.Name_uz')
        },
        {
          key:'name_ru',
          label: this.$t('message.Name_ru')
        },
        {
          key: 'name_en',
          label: this.$t('message.Name_en')
        },
        {
          key: 'name_kz',
          label: this.$t('message.Name_kr')
        },
        {
          key: 'get_level.name',
          label:this.$t('message.Position_level')
        },
        {
          key: 'action',
          label: this.$t('message.Action')
        }
      ],
      params: {
        position_level_id: null
      }
    };
  },
  computed: {
    ...layoutComputed,
  },
  created (){
    document.body.removeAttribute("data-layout", "horizontal");
    document.body.removeAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-layout-size", "boxed");
    document.body.classList.remove("auth-body-bg");
    this.fetchRank()
  },
  methods: {
    getLevel() {
       this.fetchRank()
    },
    fetchRank(){
      getPositions(this.params).then(response => {
        this.ranks = response.data.data
      })
      // createLevelById().then(response => {
      //   this.position_level = response.data.data;
      //   this.position_level.unshift({id: null,name_uz: this.$t("message.All")})
      // })
    },
    handleAdd() {
      this.id = null;
      this.activeModal = true;
      createLevelById().then(response => {
        this.position_level = response.data.data
      })
    },
    handleEdit(id) {
      this.id = id;
      this.activeModal = true;
    },
    modalClose(){
      this.activeModal = false
      this.fetchRank()
    },
    closeModal(){
      this.activeModal = false
    },
    handleDelete(id) {
      if (id) {
        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            // eslint-disable-next-line no-unused-vars
            deletePosition({ id }).then(res => {
              Swal.fire({
                icon: 'success',
                position: 'center',
                title: 'Deleted!',
                text: 'Your file has been deleted.',
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              })
              this.fetchRank()
            })
          } else if (result.dismiss === 'cancel') {
            Swal.fire({
              title: 'Cancelled',
              text: 'Your imaginary file is safe :)',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
          }
        })
      }
    },
    toggleMenu() {
      document.body.classList.toggle("sidebar-enable");
      if (window.screen.width >= 992) {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
          document.body.classList.remove("vertical-collpsed");
        });
        document.body.classList.toggle("vertical-collpsed");
      } else {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
        document.body.classList.remove("vertical-collpsed");
      }
      this.isMenuCondensed = !this.isMenuCondensed;
    },
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    },
  },
  mounted() {
    if (this.loader === true) {
      document.getElementById("preloader").style.display = "block";
      document.getElementById("status").style.display = "block";

      setTimeout(function () {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }, 2500);
    } else {
      document.getElementById("preloader").style.display = "none";
      document.getElementById("status").style.display = "none";
    }
  },
}
</script>

<style scoped>
h2{
  margin-left: 70px;
  margin-bottom: 50px;
  color: #4d63cf;
}
.bx{
  font-size: 19px;
}
</style>



